import {globalConfig} from '../components/PipeAttr/GlobalConfig';

import {setUserSetting} from "@api/map2d";

export default {
    state: {
        map:null , // 地图句柄
        drawSource:null, // 绘图图层的要素
        curFeatures:[], // 当前选中的Features数组
        globalConfig:globalConfig, // 当前选中的方案

        lines:[], // 管线
        nodes:{
            "common":[] , // 通用节点列表
            "input":[], // 输入节点列表
            "unknownInput":[], // 待求输入节点列表
            "output":[], // 输出节点列表
        }, // 节点
        mapMode:"draw", // 地图显示模式

        copyData:[], // 待拷贝的数据
        isCut: false, // 是否是剪切

        undoSnapshotData: [], // 编辑器快照数据
        redoSnapshotData: [], // 编辑器快照数据

        simutype:"steam", // 仿真类型

        globalSet:{}, // 菜单栏的全局配置
        
    },
    mutations: {
        // 设置地图
        setMap(state,map) {
            state.map=map;
        },
        setDrawSource(state,source){
            state.drawSource=source;
        },
        // 取消绘制
        cancelDraw({map}){
            let interts=map.getInteractions();
            for(let i=0;i<interts.getLength();i++){
                
            }
        },
        // 选中多个Feature
        setCurFeatures(state, features) {
            state.curFeatures = features;
        },

        // 增加管线
        setLines(state,lines){
            state.lines=lines;
        },
        // 增加节点
        setNodes(state,nodes){
            state.nodes=nodes;
        },

        // 设置当前选中方案
        setGlobalConfig(state,config){
            state.globalConfig=Object.assign({},state.globalConfig,config);
        },
        // 切换地图显示模式
        setMapMode(state,mode){
            state.mapMode=mode;
        },
        // 数据拷贝
        copy(state,copyData) {
            state.copyData =copyData;
            state.isCut = false;
        },
        // 剪切
        cut(state,copyData) {
            state.copyData =copyData;
            state.isCut = true;
        },

        // 设置仿真计算的介质类型
        setSimutype(state,type){
            state.simutype=type;
        },

        // 全局配置修改
        setGlobalSet(state,config){
            state.globalSet=config;
        },
    },
    getters:{
        // 获取默认值
        getDefault:(state)=>(type)=>{
            let res={};
            let configType=state.globalConfig.fieldSet[type];
            if(!type||!configType){
                return res;
            }
            let fields=configType.fields;
            for(let field in fields){
                res[field]=fields[field].default;
            }
            return res;
        }
    },
    actions:{
        // 保存用户设置
        saveGlobalConfig (context,config) {
            config=JSON.stringify(config);
            setUserSetting("simulation",config).then(res=>{
                if(res.status&&res.status==200){
                    console.log("用户设置保存成功");
                }
            })
        }
    }
}